import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';
import { deleteWorkOrder } from '#/graphql/mutations';
import { GET_WORK_ORDER_PROPS_COUNTS } from './useWorkOrderPropsCountsQuery';
import { GET_ASSET_RELATED_COUNTS } from '#/modules/asset/hooks/useAssetRelatedCountsQuery';

const q = gql(deleteWorkOrder);

const useWorkOrderDelete = () => {
  const [mutation, result] = useMutation(q);

  const deleteWorkOrder = useCallback(
    (workOrderId: string, assetId?: string) => {
      const refetchQueries: {
        query: typeof GET_WORK_ORDER_PROPS_COUNTS | typeof GET_ASSET_RELATED_COUNTS;
        variables?: { assetId: string };
      }[] = [];

      if (assetId) {
        refetchQueries.push({ query: GET_ASSET_RELATED_COUNTS, variables: { assetId } });
      } else {
        refetchQueries.push({ query: GET_WORK_ORDER_PROPS_COUNTS });
      }

      return mutation({
        variables: {
          id: workOrderId,
        },
        refetchQueries,
        awaitRefetchQueries: true,
      });
    },
    [mutation],
  );

  return { deleteWorkOrder, result };
};

export default useWorkOrderDelete;
